import { Component, ViewChild } from '@angular/core';
import { AlertController, NavController, NavParams } from 'ionic-angular';
import { MultiImageUpload } from "../../directives/multiimagesupload/multi-image-upload";
import { AngularFireDatabase } from 'angularfire2/database';
import { AuthProvider } from "../../providers/authservice/auth";
import { SmartanimationProvider } from "../../providers/smartanimation/smartanimation";


declare const Promise;
@Component({
  selector: 'page-managedashboard',
  templateUrl: 'managedashboard.html',
})
export class ManagedashboardPage {
  @ViewChild(MultiImageUpload) multiImageUpload: MultiImageUpload;
  @ViewChild('animateContainer') animateContainer;
  protected uploadFinished = false;
  public mitems: any;
  protected Logo: any[];
  protected Featured: any[];
  protected Address: any = {};
  private isEdit: boolean = true;
  uid: any;
  loading: boolean = true;
  loadingLogos: boolean = true;
  loadingFeatured: boolean = true;
  constructor(public navCtrl: NavController, public navParams: NavParams, private alertCtrl: AlertController, public af: AngularFireDatabase, public authProvider: AuthProvider, public animation: SmartanimationProvider) {
    console.log(this.authProvider.authState);
    if (!this.authProvider.authenticated)
      return;
    this.af.object('users/' + this.authProvider.authState.uid + '/clientId').valueChanges().subscribe(t => {
      console.log(t);
      this.uid = t;// t.$value;
      console.log("restaurant #" + this.uid);
      this.loadingLogos = true;

      this.af.list('restaurants/' + this.uid + '/Logo').snapshotChanges().map(changes => {
        return changes.map(c => ({ key: c.payload.key, ...c.payload.val() }));
      }).subscribe(t => {
        this.Logo = t;
        this.loadingLogos = false;
        console.log(this.Logo)  
      })

      this.af.list('restaurants/' + this.uid + '/Featured').snapshotChanges().map(changes => {
         return changes.map(c => ({ key: c.payload.key, ...c.payload.val() }));
      }).subscribe(t=>{
        this.Featured = t;
        this.loadingFeatured = false;
        console.log(this.Featured)
      })

      this.af.object('restaurants/' + this.uid + '/Address').valueChanges().subscribe(t => {
        this.Address = t;
        console.log(this.Address);
      });
      console.log(t);
    })

    /* this.af.object('restaurants/res4').subscribe(t => {
     this.loading = true;
     this.mitems = t;

     if (!this.mitems)
     this.mitems = {};

     if (!this.mitems.Logo)
     this.mitems.Logo = [];

     if (!this.mitems.Featured)
     this.mitems.Featured = [];

     if (!this.mitems.address)
     this.mitems.address = { res_name: '', res_address: '' };
     console.log(this.mitems);
     //this.loading = false;
     });
     /* this.af.list('restaurants/res4/Logo').subscribe(t => {
     this.Logo = t;
     });
     this.af.list('restaurants/res4/Featured').subscribe(t => {
     this.Featured = t;
     });
     this.af.object('restaurants/res4/address').subscribe(t => {
     this.Address = t;
     console.log(this.Address);
     });*/
  }

  // Confirm alert mesage
  protected confirm(text: string) {
    return new Promise((resolve) => {
      this.alertCtrl.create({
        message: text,
        buttons: [
          {
            text: 'No',
            role: 'cancel',
            handler: () => {
              resolve(false);
            }
          },
          {
            text: 'Yes',
            handler: () => {
              resolve(true);
            }
          }
        ]
      }).present();
    })

  }
  ionViewWillEnter() {
    this.animation.smartAnimation().setType('fadeIn').show(this.animateContainer.nativeElement);
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad ManagedashboardPage');
  }
  onEdit() {
    if (this.isEdit) {
      this.isEdit = false;
    }
    else {
      this.isEdit = true;
    }
  };
  submit(address: any) {
    var objToUpdate = 'restaurants/' + this.uid + '/Address';
    //  var dataToSave = {};
    this.af.object(objToUpdate).update(address);
    this.isEdit = true;
  }

}



// WEBPACK FOOTER //
// ./src/pages/managedashboard/managedashboard.ts